import { getMenuList } from '../api/services/systemService';

// 카테고리명/브랜드명 -> 비교용 slug ('JOY LIFE' -> 'joy-life', 'Joy-Life' -> 'joy-life')
export const slugifyName = (value) =>
  String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

// webuser 별 숨김 카테고리 slug 목록 (전체 메뉴 - 사용자 메뉴 차집합)
export const getHiddenCategoryKeys = async (userId) => {
  if (!userId || userId == 0) return [];
  try {
    const [fullMenuResult, userMenuResult] = await Promise.all([
      getMenuList(),
      getMenuList(userId),
    ]);
    // idWebCate 기준 차집합 (같은 이름의 카테고리가 여러 트리에 있어도 정확히 판별)
    const visibleIds = new Set(
      (userMenuResult.menuList || []).map((cat) => String(cat.idWebCate)),
    );
    return (fullMenuResult.menuList || [])
      .filter((cat) => !visibleIds.has(String(cat.idWebCate)))
      .flatMap((cat) => [slugifyName(cat.cateNm), slugifyName(cat.urlKey)])
      .filter(Boolean);
  } catch (e) {
    // 조회 실패 시 숨김 없음으로 처리 (기존 동작 유지)
    return [];
  }
};

// 이름이 숨김 카테고리에 해당하는지 (단수/복수 등 표기 차이는 부분일치로 흡수)
export const isNameHidden = (name, hiddenKeys) => {
  const key = slugifyName(name);
  if (!key || !hiddenKeys || hiddenKeys.length === 0) return false;
  return hiddenKeys.some(
    (hidden) =>
      hidden === key || hidden.startsWith(key) || key.startsWith(hidden),
  );
};
